import React, { useState } from 'react'
import { Box, Stack, Typography, styled } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import { selectEmail, selectName } from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'
import Card from '../components/Card'
import { colors } from '../themes/colors'
import { Button } from '../components/Button'
import Modal from '../components/Modal'
import { openMyFarmlands } from '../util/myFarmlands'
import apiClient from '../services/api-client'
import { AxiosError } from 'axios'
import { Loader } from '../components/Loader'

const ProfileCard = styled(Card)({
  '&:hover': {
    boxShadow: 'none',
  },
  padding: '16px',
})

export const MyAccount = () => {
  const name = useSelector(selectName)
  const email = useSelector(selectEmail)
  const navigate = useNavigate()

  const [openDeleteModal, setOpenDeleteModal] = useState(false)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<AxiosError>()

  const deleteRequest = async () => {
    const makeRequest = async () => {
      setIsLoading(true)
      try {
        const response = await apiClient.post<void, AxiosError>(`/offboarding`)

        if (response.status.toString().startsWith('2')) {
          setIsLoading(false)
        }
      } catch (err) {
        setIsLoading(false)
        setError(err as AxiosError)
        console.log('error', error)
      }

      setOpenDeleteModal(false)
      navigate('/account/delete')
    }

    makeRequest()
  }

  return (
    <PageContainer data-testid={TestIds.pages.cart}>
      <BackButton text='Home' onClick={() => navigate('/home')} />
      <>
        <YesNoAction
          display='My Account'
          body={
            <Typography variant='body2' sx={{ m: 1 }}>
              Your personal details on FarmlandsPRO
            </Typography>
          }
        />

        <ProfileCard elevation={0} variant='outlined'>
          <Stack spacing={1}>
            <Typography variant='h4' color={colors.grey800}>
              {name}
            </Typography>

            <Typography variant='body2' fontWeight={'bold'}>
              Email Address:{' '}
              <Typography component='span' fontWeight={'400'}>
                {email}
              </Typography>
            </Typography>

            <Box display='flex' justifyContent='space-between' flexWrap='wrap'>
              <Button
                sx={{
                  ml: 0,
                  pl: 0,
                  color: colors.error700,
                }}
                variant='underline'
                onClick={() => setOpenDeleteModal(true)}
              >
                Delete Account
              </Button>

              <Button variant='contained' color='primary' onClick={openMyFarmlands}>
                My Farmlands
              </Button>
            </Box>
          </Stack>
        </ProfileCard>
      </>

      <Modal
        handleClose={() => {
          setOpenDeleteModal(false)
        }}
        title='Delete your account'
        open={openDeleteModal}
        header={
          <Typography variant='body1'>
            Your FarmlandsPRO account is about to be removed. However, you will still retain your
            shareholder account with Farmlands.
          </Typography>
        }
        footer={
          isLoading ? (
            <Loader type='inline-flex' title='Requesting' sx={{ ml: 'auto' }} />
          ) : (
            <Button variant='contained' type='submit' onClick={deleteRequest}>
              Delete account
            </Button>
          )
        }
      ></Modal>
    </PageContainer>
  )
}
